var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseIconDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38256 0 0 5.38256 0 12C0 18.6174 5.38256 24 12 24C18.6174 24 24 18.6174 24 12C24 5.38256 18.6174 0 12 0ZM12 1.67452C17.7125 1.67452 22.3256 6.28744 22.3256 12.0001C22.3256 17.7126 17.7127 22.3257 12 22.3257C6.28734 22.3257 1.67442 17.7128 1.67442 12.0001C1.67442 6.28764 6.28734 1.67452 12 1.67452ZM12 3.06987C11.5377 3.06987 11.1627 3.44479 11.1627 3.90713V12.0002C11.1627 12.2314 11.2554 12.4416 11.4068 12.5931L16.7356 17.9218C17.0626 18.2487 17.5946 18.2488 17.9217 17.9218C18.2487 17.595 18.2487 17.0628 17.9217 16.7357L12.8376 11.6517V3.90748C12.8376 3.44515 12.4629 3.07022 12.0004 3.07022L12 3.06987Z",
    fill: "#FBEEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseIconDuration);
export default __webpack_public_path__ + "static/media/course_icon_duration.4fa1b01e8afeaa935d6ef99fc744038c.svg";
export { ForwardRef as ReactComponent };